/* v2-article.js - the blog post design (v2), 01/10/2026. Loaded by templates/article.liquid only, before v2.js
   (both deferred; this one comes first in the page, so it runs first), so the FAQ this builds is turned into the chat by v2.js like every other page.
   The post's words live in the Shopify admin and are not changed: this only re-arranges what is there, so the
   headings, the table and every link stay real text in the page for search engines.
   - "On this page" contents from the h2s (a sticky side list on desktop, a drop-down on phones)
   - tables: labelled cells (phones stack them as cards), our row raised in ink
   - a run of h3 entries under one h2 (a brand-by-brand rundown) becomes cards; "Name: tagline" headings split;
     an "Honest assessment:" paragraph becomes the verdict, a "Compared with Fluence:" paragraph a quiet row under it
   - a "Quick answer:" paragraph becomes the callout near the top
   - a list where every item starts in bold becomes tiles
   - the inline product box written into a post becomes the designed product card
   - the FAQ (bold questions, or h3 questions) becomes <details> in a section[data-v2-faq] -> the chat
   - Related reading -> link rows; Sources -> a drop-down with the URLs linked; the closing disclaimer -> fine print
   - two photos from the theme between sections, a reading-progress line
   Direction A chosen by Lachlan 01/10/2026 (B, the numbered index and card-rail table, was dropped). */
(function () {
  var root = document.querySelector('[data-ar]'), body = root && root.querySelector('[data-ar-body]');
  if (!body) { return; }
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var kids = function () { return [].slice.call(body.children); };
  var text = function (el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); };
  var isH2 = function (el) { return el && el.tagName === 'H2'; };
  /* the first letter after a label, capitalised ("Honest assessment: decades of..." -> label + "Decades of...") */
  function upFirst(k) {
    var n = k && k.nextSibling;
    while (n && n.nodeType === 3 && !n.textContent.trim()) { n = n.nextSibling; }
    if (n && n.nodeType === 3) { n.textContent = n.textContent.replace(/^(\s*)([a-z])/, function (m, sp, c) { return sp + c.toUpperCase(); }); }
  }
  /* a paragraph's bold lead ("Compared with Fluence:", "Quick answer:") -> a label span, colon dropped */
  function labelLead(p, cls) {
    var lead = p.firstElementChild;
    if (!lead || !/^(STRONG|B)$/.test(lead.tagName) || p.firstChild !== lead) { return; }
    var k = document.createElement('span'); k.className = cls; k.textContent = text(lead).replace(/:\s*$/, '');
    lead.replaceWith(k); upFirst(k);
  }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- the byline written into the body repeats the meta line under the title ---------- */
  var first = body.firstElementChild;
  if (first && first.tagName === 'P' && /^By .{3,80}Published/i.test(text(first))) { first.remove(); }

  /* ---------- a "Quick answer" paragraph -> the callout near the top (spec 01/10/2026, part B) ---------- */
  kids().forEach(function (el) {
    if (el.tagName === 'P' && /^quick answer/i.test(text(el))) { el.classList.add('ar-quick'); labelLead(el, 'ar-quick-k'); }
  });

  /* ---------- sections of the post, by h2 ---------- */
  /* the end-of-article product card on comparison posts (article.liquid, 24/10/2026) stays where the theme put it: never
     folded into the FAQ's last answer or an entry card */
  function sectionAfter(h) { var out = [], n = h.nextElementSibling; while (n && !isH2(n)) { if (!n.classList.contains('ar-pcard--end')) { out.push(n); } n = n.nextElementSibling; } return out; }
  var tailRe = /^(related reading|keep reading|further reading|read next|sources|references)$/i;
  var faqRe = /^(faq|faqs|frequently asked questions|questions)\b/i;

  /* ---------- FAQ -> details in a section the chat picks up ---------- */
  $$('h2', body).forEach(function (h) {
    if (!faqRe.test(text(h))) { return; }
    var items = [], cur = null;
    sectionAfter(h).forEach(function (el) {
      var lead = el.firstElementChild;
      if (el.tagName === 'P' && lead && /^(STRONG|B)$/.test(lead.tagName) && /\?\s*$/.test(text(lead)) && el.firstChild === lead) {
        var q = text(lead); lead.remove();
        cur = { q: q, a: [el] }; items.push(cur);
        if (!text(el)) { el.remove(); cur.a = []; }
      } else if (el.tagName === 'H3' && /\?\s*$/.test(text(el))) {
        cur = { q: text(el), a: [] }; items.push(cur); el.remove();
      } else if (cur) { cur.a.push(el); }
    });
    if (items.length < 3) { return; }
    var sec = document.createElement('section'); sec.className = 'ar-faq'; sec.setAttribute('data-v2-faq', '');
    var list = document.createElement('div'); list.className = 'ar-faq-list';
    h.parentNode.insertBefore(sec, h); sec.appendChild(h); sec.appendChild(list);
    items.forEach(function (it) {
      var d = document.createElement('details'), s = document.createElement('summary'), a = document.createElement('div');
      s.textContent = it.q; d.appendChild(s);
      it.a.forEach(function (el) { a.appendChild(el); });
      d.appendChild(a); list.appendChild(d);
    });
  });

  /* ---------- related reading and sources ---------- */
  $$(':scope > h2', body).forEach(function (h) {
    var t = text(h), nxt = h.nextElementSibling;
    if (/^(related reading|keep reading|further reading|read next)$/i.test(t) && nxt && /^(UL|OL)$/.test(nxt.tagName)) {
      nxt.classList.add('ar-related');
    }
    if (/^(sources|references)$/i.test(t) && nxt && /^(UL|OL)$/.test(nxt.tagName)) {
      $$('li', nxt).forEach(function (li) {
        if (li.querySelector('a')) { return; }
        li.innerHTML = li.innerHTML.replace(/(https?:\/\/[^\s<]+)/g, function (u) { return '<a href="' + u + '" rel="nofollow noopener" target="_blank">' + u.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '') + '</a>'; });
      });
      var d = document.createElement('details'), s = document.createElement('summary');
      d.className = 'ar-sources'; h.parentNode.insertBefore(d, h); s.appendChild(h); d.appendChild(s); d.appendChild(nxt);
    }
  });

  /* ---------- the closing disclaimer -> fine print (and the template's own copy steps aside) ---------- */
  var last = body.lastElementChild;
  if (last && last.tagName === 'P' && /general information only/i.test(text(last))) {
    last.classList.add('ar-fine');
    var dup = root.querySelector('[data-ar-disclaimer]'); if (dup) { dup.hidden = true; }
  }

  /* ---------- tables ---------- */
  $$('table', body).forEach(function (t) {
    var heads = $$('thead th', t).map(text);
    if (!heads.length) { var r0 = t.querySelector('tr'); if (r0) { heads = $$('th, td', r0).map(text); } }
    $$('tbody tr', t).forEach(function (tr) {
      $$('td', tr).forEach(function (td, i) { if (heads[i]) { td.setAttribute('data-label', heads[i]); } });
      var c0 = tr.querySelector('td'); if (c0 && /^fluence\b/i.test(text(c0))) { tr.classList.add('is-us'); }
    });
    var w = document.createElement('div'); w.className = 'ar-table'; t.parentNode.insertBefore(w, t); w.appendChild(t);
  });

  /* ---------- h3 runs under an h2 -> entry cards ---------- */
  $$(':scope > h2', body).forEach(function (h) {
    var els = sectionAfter(h), h3s = els.filter(function (e) { return e.tagName === 'H3' && !/\?\s*$/.test(text(e)); });
    if (h3s.length < 2) { return; }
    var wrap = document.createElement('div'); wrap.className = 'ar-entries';
    h.parentNode.insertBefore(wrap, h3s[0]);
    var entry = null;
    els.slice(els.indexOf(h3s[0])).forEach(function (el) {
      if (el.tagName === 'H3') {
        entry = document.createElement('div'); entry.className = 'ar-entry'; wrap.appendChild(entry);
        var t = text(el), c = t.indexOf(': ');
        if (c > 0 && c < 40 && !el.querySelector('a')) {
          el.innerHTML = '<span class="ar-entry-name"></span><span class="ar-entry-tag"></span>';
          el.firstChild.textContent = t.slice(0, c); el.lastChild.textContent = t.slice(c + 2);
        }
        if (/^fluence\b/i.test(t)) { entry.classList.add('is-us'); }
      }
      if (el.tagName === 'P' && /^honest assessment/i.test(text(el))) {
        el.classList.add('ar-verdict');
        el.innerHTML = el.innerHTML.replace(/^\s*(<strong>|<b>)?\s*(Honest assessment(?: of our own product)?)\s*:?\s*(<\/strong>|<\/b>)?\s*:?\s*/i, '<span class="ar-verdict-k">$2</span>');
        upFirst(el.querySelector('.ar-verdict-k'));
      }
      if (el.tagName === 'P' && /^compared with fluence/i.test(text(el))) { el.classList.add('ar-vs'); labelLead(el, 'ar-vs-k'); }
      entry.appendChild(el);
    });
  });

  /* ---------- lists where every item leads in bold -> tiles ---------- */
  $$(':scope > ul, :scope > ol', body).forEach(function (l) {
    var lis = $$(':scope > li', l);
    if (lis.length < 3 || l.classList.contains('ar-related')) { return; }
    var all = lis.every(function (li) { var f = li.firstElementChild; return f && /^(STRONG|B)$/.test(f.tagName) && text(li).indexOf(text(f)) === 0; });
    if (!all) { return; }
    l.classList.add('ar-tiles');
    lis.forEach(function (li) { var f = li.firstElementChild; f.textContent = text(f).replace(/:\s*$/, ''); });
  });

  /* ---------- three or more paragraphs in a row that lead with a bold question -> numbered blocks ---------- */
  var run = [];
  var flush = function () {
    if (run.length >= 3) {
      var ol = document.createElement('div'); ol.className = 'ar-qs';
      run[0].parentNode.insertBefore(ol, run[0]);
      run.forEach(function (p) { var b = p.firstElementChild; b.classList.add('ar-qs-k'); p.classList.add('ar-q'); ol.appendChild(p); });
    }
    run = [];
  };
  kids().forEach(function (el) {
    var b = el.firstElementChild;
    if (el.tagName === 'P' && b && /^(STRONG|B)$/.test(b.tagName) && el.firstChild === b && /\?\s*$/.test(text(b))) { run.push(el); } else { flush(); }
  });
  flush();

  /* ---------- the inline product box written into a post -> the designed card ---------- */
  $$('a[href*="/products/"][style]', body).forEach(function (a) {
    if (!a.querySelector('span')) { return; }
    var handle = (a.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1];
    var tpl = handle && document.getElementById('ar-card-' + handle);
    if (tpl) { a.replaceWith(tpl.content.cloneNode(true)); }
    else { a.removeAttribute('style'); a.className = 'ar-cta'; }
  });

  /* ---------- photos between sections (from the theme, by topic) ---------- */
  var pics = $$('[data-ar-pic]', root);
  if (pics.length) {
    var h2s = $$(':scope > h2', body).filter(function (h) { return !tailRe.test(text(h)) && !faqRe.test(text(h)); });
    var at = [Math.min(2, h2s.length - 1), Math.floor(h2s.length * 0.7)].filter(function (v, i, a) { return v > 0 && a.indexOf(v) === i; });
    at.forEach(function (idx, i) {
      var tpl = pics[i]; if (!tpl || !h2s[idx]) { return; }
      body.insertBefore(tpl.content.cloneNode(true), h2s[idx]);
    });
  }

  /* ---------- contents ---------- */
  var used = {};
  var toc = $$('h2', body).filter(function (h) { return !tailRe.test(text(h)); });
  toc.forEach(function (h) {
    var id = text(h).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
    while (used[id]) { id += '-2'; } used[id] = 1; if (!h.id) { h.id = id; }
  });
  if (toc.length >= 3) {
    var lis = toc.map(function (h) { return '<li><a href="#' + h.id + '">' + text(h).replace(/[<>&]/g, '') + '</a></li>'; }).join('');
    $$('[data-ar-toc]', root).forEach(function (box) { box.querySelector('ol').innerHTML = lis; box.hidden = false; });
    $$('[data-ar-toc] a', root).forEach(function (a) {
      a.addEventListener('click', function () { var m = a.closest('details'); if (m) { m.open = false; } });
    });
    if ('IntersectionObserver' in window) {
      var links = $$('aside[data-ar-toc] a', root);
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) { return; }
          links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + e.target.id); });
        });
      }, { rootMargin: '0px 0px -70% 0px' });
      toc.forEach(function (h) { io.observe(h); });
    }
  }

  /* ---------- reading progress ---------- */
  var bar = root.querySelector('[data-ar-progress] i'), art = root.querySelector('.ar-article');
  if (bar && art) {
    var tick = false;
    var upd = function () {
      tick = false;
      var r = art.getBoundingClientRect(), span = r.height - window.innerHeight;
      bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, span > 0 ? -r.top / span : 1)) + ')';
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

})();
